/// <amd-module name="VSSUI/Components/Table/DragAndDropGripper" />
import * as React from "react";

/**
 * The DragAndDropGripper is meant to be rendered inside of the
 * spacer column of a table, to indicate an item can be dragged in a table.
 */
export class DragAndDropGripper extends React.Component<{}> {
    public render() {
        return (
            <div className="bolt-gripper-container bolt-table-cell-content-reveal">
                <div className="bolt-gripper" />
            </div>
        );
    }
}

export function renderGripper(index: number, left: boolean) {
    if (left) {
        return <DragAndDropGripper />;
    }
    return null;
}
